/* @flow */
import React, { Component } from 'react';
import axios from 'axios';
import ajax from '../../helpers/ajax';
import RenderFormTurista from './RenderFormTurista';

export default class ContainerFormTurista extends React.Component {
	constructor(props) {
		super(props);
		this.onSubmitCliente = this.onSubmitCliente.bind(this);
		this.hideModal = this.hideModal.bind(this);
		
		this.state = {
			mostrarMensajeDeEnvio:false,
			modalVisible:true,
		};
	}

	onSubmitCliente(values){
		axios
		.post('/api/v1/formTurista/',{
			nombreApellido:values.nombreApellido,
			telefono:values.telefono,
			email:values.email,
			localidad:values.localidad,
			mensaje:values.mensaje,
			to:this.props.to
		})
		.then((result) => {
			this.setState({ mostrarMensajeDeEnvio: true })
		}) 
		.catch((err) => console.log(err));
	}

	hideModal(){
		this.setState({ modalVisible: false })
	}

	render(){
		return <RenderFormTurista
					onSubmit={this.onSubmitCliente}
					mostrarMensajeDeEnvio={this.state.mostrarMensajeDeEnvio}
					hideModal={this.hideModal}
					modalVisible={this.state.modalVisible}
				/>
	}
}